export default __webpack_public_path__ + "static/media/DF.0b59967e.webp";